<template>
  <div id="app">
    <div class="header_container">
      <div align="center">

        <div class="nav">

          <div class="items">
            <div class="logo">
              <img width="372px" height="60px" src="@/assets/header_logo.png"/>
            </div>
            <div :class="this.$route.path === '/member_info' ? 'item items_selected ':'item'">
              <router-link to="/member_info">会员中心</router-link>
            </div>
            <div :class="this.$route.path === '/my_exam' ? 'item items_selected ':'item'">
              <router-link to="/my_exam">我的试题</router-link>
            </div>
            <div :class="this.$route.path === '/my_course' ? 'item items_selected ':'item'">
              <router-link to="/my_course">我的课程</router-link>
            </div>
            <div :class="this.$route.path === '/exam_list' ? 'item items_selected ':'item'">
              <router-link to="/exam_list">在线试题</router-link>
            </div>
            <div :class="this.$route.path === '/course_list' ? 'item items_selected ':'item'">
              <router-link to="/course_list">在线课程</router-link>
            </div>
            <div class="item">
              <a href="https://www.hkmtd.com/">首页</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <el-divider></el-divider>
    <div class="copy_right"> Copyright © 2025-2030 香港人才发展中心 版权所有 粤ICP备15046821号-2</div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        header_logo_image: '@/assets/header_logo.png'
      }
    },
    mounted() {
      console.log(this.$route.path); // 输出当前路由的路径
      if (this.$route.path === '/your-path') {
        // 执行某些操作
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
  }

  .header_container {
    position: relative;
    width: 100%;
    margin: 0 0 0 0;
    padding: 0px 0px 0px 0px;
    text-align: left;
    border-top: 20px solid #f1f1f1;
    border-bottom: 20px solid #f1f1f1;
  }

  .header_container .nav {
    width: 100%;
    height: 70px;
    background-color: #FFFFFF;
  }

  .header_container .nav .items {
    min-width: 1040px;
    max-width: 1300px;
    margin: 0 200px 0 200px;
  }

  .header_container .nav .items .logo {
    position: relative;
    float: left;
    width: 372px;
    height: 60px;
    margin-top: 5px;
  }

  .header_container .nav .items .item {
    position: relative /*IE6 only*/;
    float: right;
    width: 122px;
    height: 70px;
    font-family: "微软雅黑";
    font-size: 15px;
    font-weight: bold;
    text-align: center;
  }

  .header_container .nav a {
    display: block;
    text-decoration: none;
    width: 122px;
    line-height: 70px;
    color: #000000;
    background-color: #FFFFFF;
  }
  .header_container .nav .items_selected a {
    display: block;
    text-decoration: none;
    width: 122px;
    line-height: 70px;
    color: #FFFFFF;
    background-color: #014c89;
  }
  .header_container .nav a:hover {
    color: #FFFFFF;
    background-color: #014c89;
  }
  /*.header_container .nav a {*/
  /*  background-color: #014c89;*/
  /*}*/

  .copy_right {
    height: 50px;
    line-height: 50px;
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue